import { SIZE_DESKTOP, SIZE_TABLET, SIZE_PHONE, RESPONSIVE_BREAKPOINTS } from './constants'
import { requestAccountConfirmation } from '../utils/requests'
export const sendIRTrackingEvents = (kind, productId) => {
  window.adInsights.e('info-request', kind, 'timing', productId);
  sendAnalyticsEvent({ category: 'info-request', action: 'submit', label: kind })
}

export const sendAnalyticsEvent = (event, callback) => {
  if (!window.ga) return

  const eventType = event['event'] || 'event'
  const category = event['category'] || ''
  const action = event['action'] || ''
  const label = event['label'] || ''

  window.ga('send', eventType, category, action, label, { hitCallback: callback })
}

// Send the tracking pixel to Insights (there is no need to update the data attributes)
export const trackRegisteredDownload = link => {
  if (typeof window.adInsights !== 'undefined') {
    window.adInsights.e(link.dataset.insightsCategory.replace('-non-registered', ''),
      'click',
      link.dataset.insightsLabel,
      link.dataset.insightsValue)
  }
}

// function to close last step of registration step and avoid to go to MyAD
export const closeModalOnSignUpLastStepButton = () => {
  const lastStepButton = document.querySelector('.js_kth-sbs-last_step_cta')
  if (lastStepButton) {
    lastStepButton.addEventListener('click', e => e.preventDefault())
    lastStepButton.setAttribute('rel', 'kenneth-close-modal')
    lastStepButton.innerText = window.NFT.I18n.register_button_text
  }
}

export const requireAuthToDownload = (e, link, callback) => {
  e.stopPropagation();
  e.preventDefault();

  if (window.AD && window.AD.CurrentUser && !window.AD.CurrentUser.id) {
    window.AD.reload_on_login = false;
    window.AD.openWelcome(link);
    window.AD.callback = () => {
      window.AD.redirect_uri = location.href
      window.AD.load_upper_menu()
      closeModalOnSignUpLastStepButton()
      callback(link);
    };
    return false;
  } else if ((window.AD.CurrentUser.id && !window.AD.CurrentUser.legacy_confirmed && !window.AD.CurrentUser.confirmed_at)) {
    // Add user email to modal    
    const userEmailText = document.querySelector('.user_mail_body');
    if (userEmailText && !userEmailText.innerHTML.includes(window.AD.CurrentUser.email))
      userEmailText.innerHTML += window.AD.CurrentUser.email;

    // Request confirmation and close modal
    const sendConfirmationButton = document.querySelector('.js-email-confirmation-cta')
    sendConfirmationButton &&
      sendConfirmationButton.addEventListener('click', () => {
        requestAccountConfirmation();
        window.AFD.modals.closeNow('#download_file_account_confirmation');
      });

    // Show modal  
    window.AFD.modals.open('#download_file_account_confirmation');
    return false
  }
  return callback(link);
}

/**
 * This tracks play events with Insights on video embeds with Vimeo and YouTube APIs
 */
export const initVideoTracking = () => {
  if (!window.adInsights || !window.Vimeo) return;
  if (!window.YT || !window.YT.Player) {
    document.addEventListener('youtubeapi:ready', initVideoTracking);
    return;
  }

  document.querySelectorAll('.vimeo-resource, .youtube-resource').forEach(item => {
    let videoItem;
    const { insightsCategory, insightsLabel, insightsValue, insightsVersion } = item.parentElement.dataset;
    if (item.className.includes('vimeo-resource')) {
      videoItem = new window.Vimeo.Player(item);
      videoItem.on('play', () => window.adInsights.e(insightsCategory, 'click', insightsLabel, insightsValue, insightsVersion));
      return;
    }
    videoItem = new window.YT.Player(item.id, {
      events: {
        'onStateChange': event => {
          if (event.data === window.YT.PlayerState.PLAYING) {
            window.adInsights.e(insightsCategory, 'click', insightsLabel, insightsValue, insightsVersion);
          }
        }
      }
    });
  });
}

export const requireCountryCode = callback => {
  if (window.AFD && window.AFD.countryCode) return callback();
  window.AFD = window.AFD || {};
  window.AFD.countryCodeCallbacks = [...(window.AFD.countryCodeCallbacks || []), callback];
}

const readProductId = () => document.getElementById('product-id')?.dataset.id || ''

const readProductLang = () => {
  const match = window.location.pathname.match(/^\/catalog\/([^/]+)/)
  return match ? match[1] : ''
}

export const trackProductPageInteraction = (action, callback, platform = null, folderId = null) => {
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
    if (typeof callback === 'function') callback()
    return
  }

  let callbackCalled = false
  const finish = () => {
    if (callbackCalled) return
    callbackCalled = true
    if (typeof callback === 'function') callback()
  }

  window.dataLayer.push({
    event: 'custom_event',
    type: 'click',
    internalType: 'onclick',
    eventCallback: finish,
    dimensions: {
      category: 'product',
      action: '1818,product,click',
      label: 'Product page interaction',
      dim1: readProductId(),
      dim2: readProductLang(),
      dim3: action,
      dim4: platform,
      dim5: folderId,
      dim6: null,
      dim7: null,
      dim8: null,
      dim9: null,
      dim10: null
    }
  })

  window.setTimeout(finish, 250)
}

if (typeof window !== 'undefined') {
  window.trackProductPageInteraction = trackProductPageInteraction
}

let hdDropdownTrackingInitialized = false

const hdDropdownEventTypes = {
  'hd-save': { interactionType: 'save' },
  'hd-unsave': { interactionType: 'remove' },
  'hd-share': { defaultType: 'share' },
  'hd-share-platform': { defaultType: 'share', platformEvent: true }
}

const findHdDropdownTrackingHost = event => {
  if (!event || !event.target || typeof event.target.closest !== 'function') return null

  return event.target.closest('hd-share-dropdown, hd-save-dropdown')
}

const trackHdDropdownInteraction = event => {
  const config = hdDropdownEventTypes[event.type]
  const host = findHdDropdownTrackingHost(event)

  if (!config || !host) return

  const platform = config.platformEvent ? event.detail?.platform : null
  const folderId = event.detail?.folderId ?? null
  const interactionType = config.interactionType || host.dataset.imageInteractionType || config.defaultType

  if (host.dataset.imageInteractionCategory === 'product-image') {
    trackProductImageInteraction(interactionType, null, platform)
    return
  }

  if (host.dataset.imageInteractionCategory === 'product') {
    trackProductPageInteraction(interactionType, null, platform, folderId)
    return
  }

  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return

  window.dataLayer.push({
    event: 'custom_event',
    type: 'click',
    internalType: 'onclick',
    dimensions: {
      category: host.dataset.imageInteractionCategory || '',
      action: host.dataset.imageInteractionAction || '',
      label: host.dataset.imageInteractionLabel || '',
      dim1: host.dataset.imageInteractionToken || '',
      dim2: host.dataset.imageInteractionLang || '',
      dim3: interactionType,
      dim4: platform || null,
      dim5: folderId,
      dim6: null,
      dim7: null,
      dim8: null,
      dim9: null,
      dim10: null
    }
  })
}

export const initHdDropdownTracking = () => {
  if (hdDropdownTrackingInitialized) return

  Object.keys(hdDropdownEventTypes).forEach(eventName => {
    document.addEventListener(eventName, trackHdDropdownInteraction)
  })

  hdDropdownTrackingInitialized = true
}

const readGalleryProductId = () => document.getElementById('gallery-items')?.dataset.productId || ''

const readGalleryImageId = () => document.getElementById('gallery-items')?.dataset.id || ''

export const trackProductImagePageview = imageId => {
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return

  const match = window.location.pathname.match(/^\/catalog\/([^/]+)/)
  const lang = match ? match[1] : ''

  window.dataLayer.push({
    event: 'page_view',
    dimensions: {
      category: 'product-image',
      action: '1819,product-image,pageview',
      label: 'Product image pageview',
      dim1: readGalleryProductId(),
      dim2: lang,
      dim3: imageId,
      dim4: null,
      dim5: null,
      dim6: null,
      dim7: null,
      dim8: null,
      dim9: null,
      dim10: null
    }
  })
}

export const trackProductImageInteraction = (action, callback, platform = null) => {
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
    if (typeof callback === 'function') callback()
    return
  }

  const match = window.location.pathname.match(/^\/catalog\/([^/]+)/)
  const lang = match ? match[1] : ''

  let callbackCalled = false
  const finish = () => {
    if (callbackCalled) return
    callbackCalled = true
    if (typeof callback === 'function') callback()
  }

  window.dataLayer.push({
    event: 'custom_event',
    type: 'click',
    internalType: 'onclick',
    eventCallback: finish,
    dimensions: {
      category: 'product-image',
      action: '1820,product-image,click',
      label: 'Product image interaction',
      dim1: readGalleryProductId(),
      dim2: lang,
      dim3: readGalleryImageId(),
      dim4: action,
      dim5: platform,
      dim6: null,
      dim7: null,
      dim8: null,
      dim9: null,
      dim10: null
    }
  })

  window.setTimeout(finish, 250)
}

export const scrollToElement = (element, smooth, offset = 0) => {
  const behavior = smooth ? 'smooth' : 'auto'
  try {
    if (offset) {
      const opts = {
        top: element.offsetTop + offset,
        behavior
      }
      window.scrollTo(opts)
    } else {
      element.scrollIntoView({ behavior })
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[NFT] ' + e.message);
  }
}

export const getDevice = () => {
  const widthWindow = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const { small, large } = RESPONSIVE_BREAKPOINTS
  return widthWindow >= large ? SIZE_DESKTOP : (widthWindow >= small ? SIZE_TABLET : SIZE_PHONE)
}

export const isRetina = () => window.devicePixelRatio >= 2

// Sets available viewport height considering mobile native navigation and browser controls
// Allows for full height containers to have fixed elements placed correctly
export const setMobileCSSCustomProperties = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

// TODO: Refactor this later and move accordion to its own partial
export const initAccordions = () => {
  var $category = $('.acordeon__category__title');
  var $content = $('.acordeon__content');
  var $arrow = $('.acordeon__arrow');
  var appear = 'acordeon--appear';
  var arrowUp = 'acordeon__arrow--up';

  function toggleAccordion(that) {
    var $parent = $(that).parent();
    var $brotherArrow = $parent.siblings('.acordeon__category').find($arrow);
    var $showContent = $parent.find($content);

    $parent.find($arrow).toggleClass(arrowUp);

    $brotherArrow.each(function () {
      if ($(this).hasClass(arrowUp)) {
        $(this).toggleClass(arrowUp);
      }
    });

    if (!$showContent.hasClass(appear)) {
      $content.removeClass(appear);
      $showContent.addClass(appear);

      // force call checkImpressions() once an acordeon is open
      setTimeout(function () { window.adInsights && window.adInsights.checkImpressions(); }, 500);
    } else {
      $showContent.removeClass(appear);
    }
  }

  $category.on('click', function () {
    if (AD.CurrentUser.id) {
      toggleAccordion(this)
    } else {
      var that = this
      AD.openWelcome(this)
      AD.reload_on_login = false
      AD.callback = function () {
        toggleAccordion(that)
      }
    }
  })
}

export const removeQuoteFormByDevice = quoteForm => {
  const quoteForms = document.querySelectorAll(quoteForm)
  if (!quoteForms.length) return

  quoteForms.forEach(form => {
    if (getDevice() !== SIZE_DESKTOP) form.dataset.device === 'desktop' && form.remove();
    else form.dataset.device === 'mobile' && form.remove();
  })
}
